<template>
    <div>
        <vue-topprogress ref="loadingProgress"></vue-topprogress>
        <form @submit.prevent="" class="animated fade-in" v-if="!loading">

            <div class="d-flex">
                <h1 class="display-4 font-weight-lighter">
                    {{ order ? 'Edit Order Request: ' + order.formattedName : 'New Order' }}
                </h1>
                <!-- <h1 class="ml-auto display-4 font-weight-lighter">
                    <span class="ml-auto">{{ runningTotal }}</span>
                </h1> -->
            </div>

            <b-alert v-if="order" show>Submitting a change to an order may result in an extra cost and/or delayed shipment.</b-alert>

            <div class="mb-4">
                <b-button variant="outline-dark" squared v-b-modal.order-form-policies class="mb-1 mb-sm-0 d-block d-sm-inline w-xs-100 w-sm-auto">
                    <font-awesome-icon :icon="['fal', 'file-alt']" class="mr-1"></font-awesome-icon>
                    SuperForm Ordering Policies
                </b-button>
                <order-form-policy-modal modal_id="order-form-policies"></order-form-policy-modal>
                <b-button variant="outline-dark" squared v-b-modal.product-stats class="ml-sm-3 d-block d-sm-inline w-xs-100 w-sm-auto">
                    <font-awesome-icon :icon="['fal', 'file-alt']" class="mr-1"></font-awesome-icon>
                    Product Stats
                </b-button>
                <product-stats-modal modal_id="product-stats"></product-stats-modal>
            </div>

            <c-card>
                <c-card-body>
                    <c-input
                        :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                        label="PO #"
                        v-model="form.po_number"
                        :isValid="(validation.order.po_number ? (validation.order.po_number === true) : null)"
                        :invalidFeedback="validation.order.po_number"
                    >
                        <template v-slot:label>
                            <c-col sm="2" class="col-form-label">
                                PO #
                                <font-awesome-icon
                                    class="mx-2 mt-1"
                                    :icon="['far','question-circle']"
                                    v-c-tooltip="'Please enter your PO #. If a PO # is not available enter the job name.'"
                                ></font-awesome-icon>
                            </c-col>
                        </template>
                    </c-input>
                    <b-form-group
                        label-cols-sm="6"
                        label-cols-md="4"
                        label="Requested Delivery Date"
                        class="mb-0"
                        :isValid="(validation.order.estimated_date ? (validation.order.estimated_date === true) : null)"
                        :invalidFeedback="validation.order.estimated_date"
                    >
                        <template v-slot:label>
                            Requested Delivery Date
                            <font-awesome-icon
                                class="mx-2 mt-1"
                                :icon="['far','question-circle']"
                                v-c-tooltip="'This is the date you would like to pickup/deliver your order. SuperForm Products will be in touch to discuss this requested date.'"
                            ></font-awesome-icon>
                        </template>
                        <b-form-datepicker
                            v-model="form.estimated_date"
                            :state="(validation.order.estimated_date ? (validation.order.estimated_date === true) : null)"
                        ></b-form-datepicker>
                    </b-form-group>
                </c-card-body>
            </c-card>
            <c-card>
                <c-card-body>
                    <c-select
                        :horizontal="{ label: 'col-sm-6 col-md-4', input: 'col-sm-6 col-md-8'}"
                        label="How is your order being transported?"
                        :options="transport_options"
                        :value.sync="form.transport_type"
                        class="mb-0"
                        :isValid="(validation.order.transport_type ? (validation.order.transport_type === true) : null)"
                        :invalidFeedback="validation.order.transport_type"
                    ></c-select>
                    <div v-if="form.transport_type == 'Delivery'">
                        <hr />
                        <b-alert :show="validation.drops && validation.drops !== true" variant="danger">{{ validation.drops }}</b-alert>
                        <b-tabs variant="tabs" :activeTab="'drop-tab-'+1" class="mt-2">
                            <b-tab v-for="(drop) in drops" :key="'drop-tab-'+drop" :title="'Drop '+drop">
                                <c-row class="my-3">
                                    <c-col>
                                        <div class="pr-3 border-right">
                                            <div class="h6 font-weight-bold clearfix">
                                                <span class="d-inline-block mt-1">Select an on-site contact:</span>
                                                <!-- <c-button class="float-right btn-sf btn-square btn-sm" @click="contact_modal = true"><i class="fal fa-plus"></i> New</c-button>
                                                <c-modal
                                                        title="New Contact"
                                                        :show.sync="contact_modal"
                                                >
                                                    <contact-form @cancel="contact_modal = false" @onSave="contactSave"></contact-form>
                                                    <template v-slot:footer-wrapper><div></div></template>
                                                </c-modal> -->
                                            </div>
                                            <c-input
                                                :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                                                label="Customer Name"
                                                v-model="form.contact_name"
                                                :isValid="(validation.order.contact_name ? (validation.order.contact_name === true) : null)"
                                                :invalidFeedback="validation.order.contact_name"
                                            >
                                                <template v-slot:label>
                                                    <c-col sm="2" class="col-form-label">
                                                        Customer Name
                                                        <font-awesome-icon
                                                            class="mx-2 mt-1"
                                                            :icon="['far','question-circle']"
                                                            v-c-tooltip="'The name of the on site contact for this order'"
                                                        ></font-awesome-icon>
                                                    </c-col>
                                                </template>
                                            </c-input>
                                            <c-input
                                                :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                                                label="Customer Phone Number"
                                                v-model="form.contact_number "
                                                :isValid="(validation.order.contact_number ? (validation.order.contact_number  === true) : null)"
                                                :invalidFeedback="validation.order.contact_number "
                                            >
                                                <template v-slot:label>
                                                    <c-col sm="2" class="col-form-label">
                                                        Customer Phone Number
                                                        <font-awesome-icon
                                                            class="mx-2 mt-1"
                                                            :icon="['far','question-circle']"
                                                            v-c-tooltip="'The phone number of the on site contact for this order'"
                                                        ></font-awesome-icon>
                                                    </c-col>
                                                </template>
                                            </c-input>
                                            <c-input
                                                :horizontal="{ label: 'col-sm-2', input: 'col-sm-10'}"
                                                label="Customer Email"
                                                v-model="form.contact_email "
                                                :isValid="(validation.order.contact_email ? (validation.order.contact_email  === true) : null)"
                                                :invalidFeedback="validation.order.contact_email "
                                            >
                                                <template v-slot:label>
                                                    <c-col sm="2" class="col-form-label">
                                                        Customer Email
                                                        <font-awesome-icon
                                                            class="mx-2 mt-1"
                                                            :icon="['far','question-circle']"
                                                            v-c-tooltip="'The email of the on site contact for this order'"
                                                        ></font-awesome-icon>
                                                    </c-col>
                                                </template>
                                            </c-input>
                                        </div>
                                    </c-col>
                                    <c-col>
                                        <div class="pl-3">
                                            <div class="h6 font-weight-bold clearfix">
                                                <span class="d-inline-block mt-1">Select a drop location:</span>
                                                <c-button class="float-right btn-sf btn-square btn-sm" @click="location_modal = true"><i class="fal fa-plus"></i> New</c-button>
                                                <c-modal
                                                        title="New Location"
                                                        :show.sync="location_modal"
                                                >
                                                    <location-form @cancel="location_modal = false" @onSave="locationSave"></location-form>
                                                    <template v-slot:footer-wrapper><div></div></template>
                                                </c-modal>
                                            </div>
                                            <b-form-group>
                                                <b-form-radio-group
                                                        v-model="selected_locations[drop]"
                                                        :options="location_options"
                                                        stacked
                                                        buttons
                                                        size="sm"
                                                        class="w-100"
                                                ></b-form-radio-group>
                                            </b-form-group>
                                        </div>
                                    </c-col>
                                    <b-col cols="12">
                                        <div class="h6 font-weight-bold">
                                            Drop Note:
                                        </div>
                                        <c-textarea v-model="drop_notes[drop]"></c-textarea>
                                    </b-col>
                                </c-row>
                            </b-tab>
                        </b-tabs>
                    </div>
                    <div v-else-if="form.transport_type == 'Pickup'">
                        <hr />
                        <div class="h6 font-weight-bold">
                            Pickup Note:
                        </div>
                        <c-textarea v-model="drop_notes[1]"></c-textarea>
                    </div>
                </c-card-body>
            </c-card>
            <c-card>
                <c-card-body>
                    <b-alert :show="validation.order_items && validation.order_items !== true" variant="danger">{{ validation.order_items }}</b-alert>

                    <div class="d-block d-lg-none">
                        <div v-for="(item, index) in items" :key="'order-item-list-'+index">

                            <b-row class="product-selection">
                                <b-col cols="12"><div class="pb-1">Product</div></b-col>
                                <b-col v-if="item.type.name === 'Blocks'">
                                    <div v-if="item.type.product_categories">
                                        <b-select v-model="item.product_id" required>
                                            <b-select-option value="">-- Choose --</b-select-option>
                                            <b-select-option-group 
                                                v-for="(category) in item.type.product_categories" 
                                                :label="category.name"
                                                :key="'block-product-category-'+category.id"
                                            >
                                                <b-select-option
                                                        v-for="(product) in category.products"
                                                        :key="'block-product-'+product.id"
                                                        :value="product.id"
                                                >{{decodeHTMLEntities(product.name)}}</b-select-option>
                                            </b-select-option-group>
                                        </b-select>
                                    </div>
                                </b-col>
                                <b-col v-if="item.type.name === 'Insulation'">
                                    <div v-if="item.type.product_classifications" class="clearfix">
                                        <b-select v-model="item.product_id" class="w-100 float-left" required>
                                            <b-select-option value="">-- Choose --</b-select-option>
                                            <b-select-option-group 
                                                v-for="(classification) in item.type.product_classifications" 
                                                :label="classification.name"
                                                :key="'insulation-classification-'+classification.id"
                                            >
                                                <b-select-option
                                                    v-for="(product) in classification.products"
                                                    :value="product.id"
                                                    :key="'insulation-product-'+product.id"
                                                >{{decodeHTMLEntities(product.name)}}</b-select-option>
                                            </b-select-option-group>
                                        </b-select>
                                        <b-input-group class="w-100 float-left">
                                            <b-form-input type="number" step="0.01" v-model="item.insulation_cut.thickness" placeholder="Thickness" required></b-form-input>
                                            <b-form-select v-model="item.insulation_cut.thickness_unit" :selected="'in'" :options="['in']" required></b-form-select>
                                        </b-input-group>
                                        <b-input-group class="w-100 float-left">
                                            <b-form-input type="number" step="0.01" v-model="item.insulation_cut.width" placeholder="Width" required></b-form-input>
                                            <b-form-select v-model="item.insulation_cut.width_unit" :selected="'ft'" :options="['ft','in']" required></b-form-select>
                                        </b-input-group>
                                        <b-input-group class="w-100 float-left">
                                            <b-form-input type="number" step="0.01" v-model="item.insulation_cut.length" placeholder="Length" required></b-form-input>
                                            <b-form-select v-model="item.insulation_cut.length_unit" :selected="'ft'" :options="['ft','in']" required></b-form-select>
                                        </b-input-group>
                                    </div>
                                </b-col>
                                <b-col v-if="item.type.name === 'Accessories'">
                                    <div v-if="item.category">
                                        <b-select v-model="item.product_id" required>
                                            <b-select-option value="">-- Choose --</b-select-option>
                                            <b-select-option-group v-if="item.category" :label="item.category.name">
                                                <b-select-option
                                                    v-for="(product) in item.category.products"
                                                    :value="product.id"
                                                    :key="'acc-product-'+product.id"
                                                >{{decodeHTMLEntities(product.name)}}</b-select-option>
                                            </b-select-option-group>
                                        </b-select>
                                    </div>
                                </b-col>
                                <b-col v-if="item.type.name === 'Other'">
                                    <b-form-input type="text" v-model="item.description" placeholder="Custom" required></b-form-input>
                                </b-col>
                            </b-row>

                            <b-form-group label-cols="12" label="Drop" class="mb-0">
                                <b-select v-model="item.drop">
                                    <b-select-option 
                                        v-for="(drop, drop_index) in drops" 
                                        :key="'drop-select-option-'+drop_index"
                                        :value="drop" 
                                        required
                                    >{{ drop }}</b-select-option>
                                </b-select>
                            </b-form-group>

                            <b-form-group v-if="item.type.name === 'Blocks'" label-cols="12" label="Quantity" class="mb-0">
                                <template v-slot:label>
                                    Quantity
                                    <font-awesome-icon
                                        class="mx-2 mt-1"
                                        :icon="['far','question-circle']"
                                        v-c-tooltip="'ICF is ordered in sets of 4.'"
                                    ></font-awesome-icon>
                                </template>
                                <b-form-input type="number" v-model="item.quantity" required step="4" @blur="(e) => blockValueFilter(e, index, item)"></b-form-input>
                            </b-form-group>
                            <b-form-group v-else label-cols="12" label="Quantity" class="mb-0">
                                <b-form-input type="number" v-model="item.quantity" required></b-form-input>
                            </b-form-group>

                            <b-form-group label-cols="12" label="Fill?" class="mb-0">
                                <template v-slot:label>
                                    Fill?
                                    <font-awesome-icon
                                        class="mx-2 mt-1"
                                        :icon="['far','question-circle']"
                                        v-c-tooltip="'Please select if you would like to fill your order with this product.'"
                                    ></font-awesome-icon>
                                </template>
                                <b-form-radio-group
                                    v-model="item.fill"
                                    :options="[{value: false, text: 'No'},{value: true, text: 'Yes'}]"
                                    buttons
                                    size="sm"
                                    class="w-100"
                                ></b-form-radio-group>
                            </b-form-group>
                            
                            <div class="clearfix"><b-button variant="sf" squared class="mt-2 float-right"><font-awesome-icon :icon="['fal','trash']" @click="deleteRow(index)"></font-awesome-icon></b-button></div>

                            <hr style="border-top: 2px solid rgba(0, 0, 0, 0.6);" />
                        </div>
                    </div>

                    <div class="clearfix mb-lg-3">
                        <div class="float-right w-xs-100">
                            <div v-for="(type) in product_types" class="d-block d-sm-inline-block">
                                <div v-if="hasTypeAccess(type)" class="d-block d-sm-inline-block" >
                                    <c-button v-if="type.name !== 'Accessories'" @click="addTypeRow(type)" class="btn-sf btn-square ml-sm-2 mt-1 mt-sm-0 w-xs-100 w-sm-auto" size="sm">
                                        <i class="fal fa-plus"></i> {{ (type.name === 'Other' ? 'Custom' : type.name) }}
                                    </c-button>
                                    <div v-if="type.name === 'Accessories'" class="d-block d-sm-inline-block">
                                        <div v-for="(category) in type.product_categories" class="d-block d-sm-inline-block">
                                            <c-button v-if="!['None', 'Raw Product', 'Apparel', 'Shop Supplies', '2nd ICF', 'Marketing Assets'].includes(category.name)" @click="addCategoryRow(type, category)" class="btn-sf btn-square ml-sm-2 mt-1 mt-sm-0 w-xs-100 w-sm-auto" size="sm">
                                                <i class="fal fa-plus"></i> {{category.name}}
                                            </c-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <c-data-table :fields="fields" :items="items" class="d-none d-lg-block">
                        <template #actions="{item, index}">
                            <td width="50">
                                <c-button @click="deleteRow(index)" class="btn-sf btn-square" size="sm"><i class="fal fa-trash"></i></c-button>
                            </td>
                        </template>
                        <template #previews="{item}">
                            <td width="150">
                                <document-preview
                                    v-if="item.product_id && getProductImage(item.product_id)"
                                    :document="getProductImage(item.product_id)"
                                    class="d-inline-block float-left mr-3"
                                    :width="100"
                                ></document-preview>
                                <span v-else>N/A</span>
                            </td>
                        </template>
                        <template #products="{item}">
                            <td>
                                <div v-if="item.type.name === 'Blocks'">
                                    <div v-if="item.type.product_categories">
                                        <b-select v-model="item.product_id" required>
                                            <b-select-option value="">-- Choose --</b-select-option>
                                            <b-select-option-group 
                                                v-for="(category) in item.type.product_categories" 
                                                :label="category.name"
                                                :key="'block-product-category-'+category.id"
                                            >
                                                <b-select-option
                                                        v-for="(product) in category.products"
                                                        :key="'block-product-'+product.id"
                                                        :value="product.id"
                                                >{{decodeHTMLEntities(product.name)}}</b-select-option>
                                            </b-select-option-group>
                                        </b-select>
                                    </div>
                                </div>
                                <div v-if="item.type.name === 'Insulation'">
                                    <div v-if="item.type.product_classifications" class="clearfix">
                                        <b-select v-model="item.product_id" class="w-100 float-left" required>
                                            <b-select-option value="">-- Choose --</b-select-option>
                                            <b-select-option-group 
                                                v-for="(classification) in item.type.product_classifications" 
                                                :label="classification.name"
                                                :key="'insulation-classification-'+classification.id"
                                            >
                                                <b-select-option
                                                    v-for="(product) in classification.products"
                                                    :value="product.id"
                                                    :key="'insulation-product-'+product.id"
                                                >{{decodeHTMLEntities(product.name)}}</b-select-option>
                                            </b-select-option-group>
                                        </b-select>
                                        <b-input-group class="w-100 float-left">
                                            <b-form-input type="number" step="0.01" v-model="item.insulation_cut.thickness" placeholder="Thickness" required></b-form-input>
                                            <b-form-select v-model="item.insulation_cut.thickness_unit" :selected="'in'" :options="['in']" required></b-form-select>
                                        </b-input-group>
                                        <b-input-group class="w-100 float-left">
                                            <b-form-input type="number" step="0.01" v-model="item.insulation_cut.width" placeholder="Width" required></b-form-input>
                                            <b-form-select v-model="item.insulation_cut.width_unit" :selected="'ft'" :options="['ft','in']" required></b-form-select>
                                        </b-input-group>
                                        <b-input-group class="w-100 float-left">
                                            <b-form-input type="number" step="0.01" v-model="item.insulation_cut.length" placeholder="Length" required></b-form-input>
                                            <b-form-select v-model="item.insulation_cut.length_unit" :selected="'ft'" :options="['ft','in']" required></b-form-select>
                                        </b-input-group>
                                    </div>
                                </div>
                                <div v-if="item.type.name === 'Accessories'">
                                    <div v-if="item.category">
                                        <b-select v-model="item.product_id" required>
                                            <b-select-option value="">-- Choose --</b-select-option>
                                            <b-select-option-group v-if="item.category" :label="item.category.name">
                                                <b-select-option
                                                    v-for="(product) in item.category.products"
                                                    :value="product.id"
                                                    :key="'acc-product-'+product.id"
                                                >{{decodeHTMLEntities(product.name)}}</b-select-option>
                                            </b-select-option-group>
                                        </b-select>
                                    </div>
                                </div>
                                <div v-if="item.type.name === 'Other'">
                                    <b-form-input type="text" v-model="item.description" placeholder="Custom" required></b-form-input>
                                </div>
                            </td>
                        </template>
                        <template #quantity="{item, index}">
                            <td width="145">
                                <div v-if="item.type.name === 'Blocks'">
                                    <b-form-group>
                                        <b-form-input type="number" v-model="item.quantity" required step="4" class="w-75 d-inline-block" @blur="(e) => blockValueFilter(e, index, item)"></b-form-input>
                                        <font-awesome-icon
                                                class="mx-2 mt-1"
                                                :icon="['far','question-circle']"
                                                v-c-tooltip="{content: 'ICF is ordered in sets of 4.', placement: 'left'}"
                                        ></font-awesome-icon>
                                    </b-form-group>
                                </div>
                                <b-form-input v-else type="number" v-model="item.quantity" required></b-form-input>
                            </td>
                        </template>
                        <template #drop="{item}">
                            <td width="100">
                                <b-select v-model="item.drop">
                                    <b-select-option v-for="(drop) in drops" :value="drop" required>{{ drop }}</b-select-option>
                                </b-select>
                            </td>
                        </template>
                        <template #fill="{item}">
                            <td width="145">
                                <b-form-group>
                                    <b-form-radio-group
                                            v-model="item.fill"
                                            :options="[{value: false, text: 'No'},{value: true, text: 'Yes'}]"
                                            buttons
                                            size="sm"
                                    ></b-form-radio-group>
                                    <font-awesome-icon
                                            class="mx-2 mt-1"
                                            :icon="['far','question-circle']"
                                            v-c-tooltip="{content: 'Please select if you would like to fill your order with this product.', placement: 'left'}"
                                    ></font-awesome-icon>
                                </b-form-group>
                            </td>
                        </template>
                        <template #specs="{item, index}">
                            <td width="150">
                                <document-preview
                                        v-if="item.product_id && getProductSpec(item.product_id)"
                                        :document="getProductSpec(item.product_id)"
                                        class="d-inline-block float-left mr-3"
                                        :width="100"
                                ></document-preview>
                                <span v-else>N/A</span>
                            </td>
                        </template>
                    </c-data-table>

                </c-card-body>
            </c-card>

            <c-card>
                <c-card-body>
                    <label for="order-note">Please add all notes or concerns regarding this order below:</label>
                    <c-textarea id="order-note" v-model="note"></c-textarea>
                </c-card-body>
            </c-card>

            <c-card>
                <c-card-body>
                    <label for="order-note">Attach any PO documents, custom drawings, or any related files to this order:</label>
                    <upload-table :show_header="false" :hidden_fields="['size','description']" :documents="documents" @change="documents => updateDocuments(documents)"></upload-table>
                </c-card-body>
            </c-card>

            <b-alert :show="is_valid === false" variant="danger">Some of the fields above are not complete please scroll up and review your information.</b-alert>

            <div class="clearfix mb-5">
                <div class="d-inline-block  float-right">
                    <c-modal size="xl" title="Review the order below:" :show.sync="preview">
                        <bill-of-lading v-if="order_commit" :orderTotal="runningTotal" :order_commit="order_commit" :customer="customer" title="Order Review" :preview="true"></bill-of-lading>
                        <div v-else><b-overlay show><div class="py-5"></div></b-overlay></div>
                        <!-- <b-alert show>Please note: This order is subject to taxes and fees which may affect the order's total amount.</b-alert> -->
                        <template v-slot:footer-wrapper>
                            <div class="p-4 clearfix">
                                <b-progress v-if="step" :max="max_step" height="1.8rem" class="mb-4">
                                    <b-progress-bar :value="step" :variant="save_error ? 'warning' : null">
                                        <b>{{save_error ? save_error : step_message}}</b>
                                    </b-progress-bar>
                                </b-progress>
                                <div class="d-inline-block  float-right">
                                    <b-overlay :show="saving" spinner-small>
                                        <c-button class="btn-sf btn-square" @click.prevent="saveOrder">
                                            <i class="fal fa-save"></i> Save Order
                                        </c-button>
                                    </b-overlay>
                                </div>
                                <div class="d-inline-block  float-right">
                                    <c-button class="btn-square btn-secondary mr-2" @click="preview=false">
                                        Back
                                    </c-button>
                                </div>
                            </div>
                        </template>
                    </c-modal>
                    <b-overlay :show="preview" spinner-small>
                        <c-button class="btn-sf btn-square" @click.prevent="reviewOrder">
                            <i class="fal fa-save"></i> Review & Save
                        </c-button>
                    </b-overlay>
                    <!-- <b-overlay :show="saving" spinner-small>
                        <c-button class="btn-sf btn-square" type="submit">
                            <i class="fal fa-save"></i> Save Order
                        </c-button>
                    </b-overlay> -->
                </div>
            </div>
        </form>
    </div>
</template>

<script>
  import Product from "@/models/Product"
  import ProductCategory from "@/models/ProductCategory"
  import ProductClassification from "@/models/ProductClassification"
  import ProductType from "@/models/ProductType"
  import CustomerContact from "@/models/CustomerContact"
  import CustomerLocation from "@/models/CustomerLocation"
  import ContactForm from "@/components/order/form/ContactForm"
  import LocationForm from "@/components/order/form/LocationForm";
  import UploadTable from "@/components/documents/UploadTable";
  import OrderCreate from "@/helpers/OrderCreate";
  import OrderFormPolicyModal from "@/components/order/form/OrderFormPolicyModal";
  import DocumentPreview from "@/components/documents/DocumentPreview";
  import BillOfLading from "@/components/order/print/BillOfLading";
  import {GREEDY_FETCH_ENTITY} from "@/store/action-types";
  import moment from "moment";
  import Customer from "../../../models/Customer";
  import ProductStatsModal from "./ProductStatsModal";

  import ToastNotifications from "@/components/shared/mixins/ToastNotifications";

  export default {
      name: 'OrderForm',
      components: {ProductStatsModal, DocumentPreview, OrderFormPolicyModal, UploadTable, LocationForm, ContactForm, BillOfLading},
      mixins: [ToastNotifications],
      props: ['order'],
      data () {
        return {
          loading: true,
          saving: false,
          preview: false,

          step: null,
          step_message: null,
          max_step: null,
          save_error: null,

          form: {
            number: null,
            po_number: null,
            estimated_date: null,
            transport_type: null
          },

          customer: null,
          order_commit: null,

          note: null,
          drops: [1,2,3],
          product_types: [],
          products: [],
          transport_options: [
            {value: '', label: 'Select a transport type'},
            {value: 'Pickup', label: 'Pickup'},
            {value: 'Delivery', label: 'Delivery'}
          ],
          fields: [
          	{key: 'actions', label: 'Actions'},
            {key: 'previews', label: 'Preview(s)'},
            {key: 'products', label: 'Product(s)'},
            {key: 'quantity', label: 'Qty'},
            {key: 'drop', label: 'Drop'},
            {key: 'fill', label: 'Fill', },
            {key: 'specs', label: 'Spec(s)'},
          ],
          items: [],
          selected_contacts: {1: null, 2: null, 3: null},
          contact_options: [],
          selected_locations: {1: null, 2: null, 3: null},
          location_options: [],
          contact_modal: false,
          location_modal: false,
          drop_notes: {1: null, 2: null, 3: null},
          documents: [],
          is_valid: null,
          validation: OrderCreate.validationDefaults()
        }
      },
      computed: {
            categoryListForCustomer() {
                const categoriesList = _.uniq(
                    _.map(this.productListForCustomer, (product) => { 
                        return product.product ? product.product.product_category.name : 'No Category'
                    })
                );
                return categoriesList;
            }
      },
      methods: {
            filterOutCategoriesInPriceList() {
                const categoriesList = _.uniq(_.map(this.productListForCustomer, (product) => { 
                    return product.product ? product.product.product_category.name : 'No Category'
                }));
              return categoriesList ;
          },
          filterOutProductsInPriceList(products) { 
              return _.filter(products, (product) => { return this.productListForCustomer[product.id] }); 
            },
        getProductImage(product_id) {
          let product = Product.query().with(['images']).whereId(product_id).first();
          if(product && product.getPrimaryImage()) {
            return product.getPrimaryImage();
          }
          return null;
        },
        getProductSpec(product_id) {
          let product = Product.query().with(['specifications']).whereId(product_id).first();
          if(product && product.getPrimarySpecification()) {
            return product.getPrimarySpecification();
          }
          return null;
        },
        addTypeRow(type) {
          this.newRow(type);
        },
        addCategoryRow(type, category) {
          this.newRow(type, category);
        },
        newRow(type, category, product, item) {
            console.log(type);
          this.items.push({
            type: type,
            category: category,
            product_id: product ? product.id : null,
            insulation_cut: {
              thickness: (item && item.insulation_cut && item.insulation_cut.thickness ? item.insulation_cut.thickness : null),
              thickness_unit: (item && item.insulation_cut && item.insulation_cut.thickness_unit ? item.insulation_cut.thickness_unit : (type && type.name === 'Insulation' ? 'in' : null)),
              width: (item && item.insulation_cut && item.insulation_cut.width ? item.insulation_cut.width : null),
              width_unit: (item && item.insulation_cut && item.insulation_cut.width_unit ? item.insulation_cut.width_unit : (type && type.name === 'Insulation' ? 'ft' : null)),
              length: (item && item.insulation_cut && item.insulation_cut.length ? item.insulation_cut.length : null),
              length_unit: (item && item.insulation_cut && item.insulation_cut.length_unit ? item.insulation_cut.length_unit : (type && type.name === 'Insulation' ? 'ft' : null)),
            },
            quantity: item && item.quantity ? item.quantity : null,
            drop: item && item.drop ? item.drop : 1,//1,
            fill: item && item.fill ? item.fill : false,//false,
            description: item && item.description ? item.description : null,//null,
            id: item && item.id ? item.id : null,//null,
          });
        },
        deleteRow(index) {
          this.items.splice(index, 1);
        },
        updateDocuments(documents) {
          this.documents = documents;
        },
        createHandlerFromFormData() {
          //:: Prepare Order Payload
          let payload = JSON.parse(JSON.stringify(this.form));
          if(payload.transport_type === 'Delivery') {
            payload.delivery = true;
          } else if(payload.transport_type === 'Pickup') {
            payload.pickup = true;
          }
          //:: Prepare Order Items Payload
          let items = JSON.parse(JSON.stringify(this.items));
          //:: Prepare Order Contacts
          let contacts = JSON.parse(JSON.stringify(this.selected_contacts));
          //:: Prepare Order Locations
          let locations = JSON.parse(JSON.stringify(this.selected_locations));
          //:: Prepare Order Notes
          let notes = [];
          if(this.note) {
            notes.push({drop: null, note: this.note});
          }
          let temp = JSON.parse(JSON.stringify(this.drop_notes));
          for(let i in temp) {
            if(temp[i]) {
              notes.push({drop: i, note: temp[i]});
            }
          }
          //:: Prepare Order Documents
          let documents = JSON.parse(JSON.stringify(this.documents));

          return (new OrderCreate(payload, items, contacts, locations, notes, documents));
        },
        reviewOrder() {
          this.is_valid = null;
          let handler = this.createHandlerFromFormData();
          if(!handler.validate()) {
            this.is_valid = false;
            this.validation = handler.validation;
            return false;
          }
          this.preview = true;
          this.order_commit = {data: handler.getCommitData()};
        },
        saveOrder() {

          this.is_valid = null;
          this.saving = true;
          this.save_error = null;
          let handler = this.createHandlerFromFormData();

          if(!handler.validate()) {
            this.is_valid = false;
            this.validation = handler.validation;
            this.saving = false;
            return false;
          }

          if(this.order) {
            return handler.commit(this.order).then((order) => {
                if(order) {
                    this.quickSuccessToast('Order Changes Sent', 'The changes were sent for review, you will be sent a notification when they are eith approved or declined.');
                    this.$router.push('/orders' + (order['id'] ? '/' + order['id'] : null));
                    this.saving = false;
                }
            }, () => {
              this.saving = false;
            });
          }

          handler.setStepCallback((step, step_message, max_step) => {
              this.step = step;
              this.step_message = step_message;
              this.max_step = max_step;
          });
          handler.setErrorCallback((err) => {
            this.save_error = err;
            this.saving = false;
          });

          return handler.run().then((order) => {
            if(order) {
              this.quickSuccessToast('Order Created', 'The order was created successfully.');
              this.$router.push('/orders' + (order['id'] ? '/' + order['id'] : null));
              this.saving = false;
            }
          });

        },
        decodeHTMLEntities(text) {
          let textArea = document.createElement('textarea');
          textArea.innerHTML = text;
          return textArea.value;
        },
        fetch() {
            return Promise.all([
              this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: ProductType}),
              this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: ProductCategory}),
              this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: ProductClassification}),
              this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: Product}),
              this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: CustomerContact}),
              this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: CustomerLocation}),
              Customer.api().retrieve(this.$store.getters.getAuthCustomerID),
            ]);
        },
        populate() {
            return new Promise((resolve) => {
              let customer_id = this.$store.getters.getAuthCustomerID;
              this.product_types = ProductType.query().with([
                'product_categories.products',
                'product_classifications.products'
              ], (query) => {
               query.orderBy('number');
              }).get();
              this.contact_options = [{ text: 'N/A', value: null }];
              CustomerContact.query().where('customer_id', Math.abs(customer_id)).with('contact').get().forEach((customer_contact) => {
                let contact = customer_contact.contact;
                if(contact) {
                  this.contact_options.push({
                    text: [contact.full_name, contact.email, contact.phone, contact.mobile].filter(x => x).join(' - '),
                    value: contact.id
                  });
                }
              });
              this.location_options = [{ text: 'N/A', value: null }];
              CustomerLocation.query().where('customer_id', Math.abs(customer_id)).with('location').get().forEach((customer_location) => {
                let location = customer_location.location;
                if(location) {
                  this.location_options.push({ text: location.address, value: location.id });
                }
              });
              this.customer = Customer.find(customer_id);
              this.fillWithOrder();
              resolve();
            });
        },
        fillWithOrder() {
            if(this.order) {
                this.form.number = this.order.number;
                this.form.po_number = this.order.po_number;
                this.form.estimated_date = moment(this.order.estimated_date).format('YYYY-MM-DD');
                this.form.transport_type = (this.order.delivery ? 'Delivery' : 'Pickup');
                this.order.order_items.forEach((item) => {
                    let item_product = Product.query().where('id', item.product_id).with(['product_category.products', 'product_type.product_classifications.products', 'product_type.product_categories.products']).first();
                    if(item_product) {
                      this.newRow(item_product.product_type, item_product.product_category, item_product, item);
                    } else {
                      this.newRow(ProductType.query().where('name','Other').first(), null, null, item);
                    }
                });
                this.order.order_contacts.forEach((order_contact) => {
                    if(order_contact.drop && order_contact.contact) {
                        this.selected_contacts[order_contact.drop] = order_contact.contact.id;
                    }
                });
                this.order.order_locations.forEach((order_location) => {
                    if(order_location.drop && order_location.location) {
                        this.selected_locations[order_location.drop] = order_location.location.id;
                    }
                });
                this.order.order_notes.forEach((order_note) => {
                    if(order_note.drop && order_note.note) {
                        this.drop_notes[order_note.drop] = order_note.note.note;
                    } else {
                        this.note = order_note.note.note;
                    }
                });
            }
        },
        fillWithFake() {
            this.form.number = null;
            this.form.po_number = this.$faker().random.number();
            this.form.estimated_date = moment().add(1, 'days').format('YYYY-MM-DD');
            this.form.transport_type = 'Delivery';
            let contact = this.contact_options.find(i=>i.text && i.text.includes('kolby@tangle.ca'));
            if(!contact) {
                contact = this.contact_options.find(i=>!!i.value);
            }
            this.selected_contacts[1] = contact.value;
            this.selected_contacts[2] = contact.value;
            this.selected_contacts[3] = contact.value;
            let location = this.location_options.find(i=>!!i.value);
            this.selected_locations[1] = location.value;
            this.selected_locations[2] = location.value;
            this.selected_locations[3] = location.value;
            this.drop_notes[1] = this.$faker().lorem.sentence();
            this.drop_notes[2] = this.$faker().lorem.sentence();
            this.drop_notes[3] = this.$faker().lorem.sentence();
            this.note = this.$faker().lorem.sentence();
            let types = ProductType.query().with([
                'product_categories.products', 
                'product_categories.product_classifications.products', 
                'product_classifications.products', 
                'products', 
                'products.product_category', 
                'products.product_category.product_type',
                'products.product_category.products', 
            ]).get();
            [1,2,3].forEach((drop) => {
                types.forEach((type) => {
                    let item = {
                        drop: drop, 
                        quantity: this.$faker().random.number({min: 1, max: 20}), 
                        fill: 0, 
                        description: null
                    };
                    if(type.name !== 'Other') {
                        if(type.name === 'Blocks') {
                            item.quantity = Math.ceil(Math.abs(item.quantity) / 4) * 4;
                        }
                        if(type.name === 'Insulation') {
                            item.insulation_cut = {
                                thickness: this.$faker().random.number({min: 1, max: 20}),
                                width: this.$faker().random.number({min: 1, max: 20}),
                                length: this.$faker().random.number({min: 1, max: 20}),
                            };
                        }
                        let product = type.products[Math.floor(Math.random() * type.products.length)];
                        if(type.name === 'Accessories') {
                           let category_name = product.product_category.name;
                           while(category_name === 'None' || category_name === 'Raw Product' || category_name === 'Apparel') {
                               product = type.products[Math.floor(Math.random() * type.products.length)];
                               category_name = product.product_category.name;
                           }
                        }
                        console.log(product.product_category);
                        this.newRow(type, product.product_category, product, item);
                    } else {
                        item.description = this.$faker().lorem.words();
                        this.newRow(type, null, null, item);
                    }
                });
            });
        },
        contactSave(customer_contact, contact) {
          this.contact_modal = false;
          this.contact_options.push({
            text: [contact.full_name, contact.email, contact.phone, contact.mobile].join(' - '),
            value: contact.id
          });
        },
        locationSave(customer_location, location) {
          this.location_modal = false;
          this.location_options.push({
            text: location.address,
            value: location.id
          });
        },
        blockValueFilter(e, index, item) {
          item.quantity = Math.ceil(Math.abs(e.target.value) / 4) * 4;
          this.items.splice(index, 1, item);
        },
        hasTypeAccess(type) {
          let access = this.customer ? this.customer.product_type_access : [];
          return access.includes(type.name);
        }
      },
      watch: {
          '$route.query.fake': function(v) {
              if(!!v) {
                  this.fillWithFake();
              }
          }
      },
      mounted() {
        this.$refs.loadingProgress.start();
        this.fetch().then(() => {
          this.populate().then(() => {
            this.loading = false;
            this.$refs.loadingProgress.done();
          });
        });
      },
      created() {
        this.loading = true;
      }
	}
</script>
<style>
    .custom-select {
        font-size: 0.85rem;
    }
</style>
